import { useState, useEffect } from 'react'

/**
 * Animated number that counts up from 0 to target value.
 * Uses ease-out cubic easing for a premium feel.
 */
export default function AnimatedNumber({ value, duration = 600, className = '' }) {
  const [display, setDisplay] = useState(0)

  useEffect(() => {
    let start = 0
    const startTime = performance.now()
    const step = (now) => {
      const elapsed = now - startTime
      const progress = Math.min(elapsed / duration, 1)
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3)
      setDisplay(Math.round(start + (value - start) * eased))
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }, [value, duration])

  return (
    <span className={`tabular-nums font-extrabold ${className}`}>
      {display}
    </span>
  )
}
